import React from "react";
import Modal from "../../../components/Modal";
import styles from "./Invites.module.sass";
import tablestyles from "../../../components/Table/Table.module.sass";

import Card from "../../../components/Card";
import Row from "./col";
const InviteList = ({ isOpen, onClose, invites }) => {
	return (
		<Modal
			outerClassName={styles.outerClassName}
			visible={isOpen}
			onClose={onClose}
		>
			<Card title="Invitations" classTitle="title-green">
				<div className={tablestyles.table}>
					<div className={tablestyles.row}>
						<div className={tablestyles.col}></div>
						<div className={tablestyles.col}>Created by</div>
						<div className={tablestyles.col}>Sent to</div>
						<div className={tablestyles.col}>Role</div>
						<div className={tablestyles.col}>Status</div>
						<div className={tablestyles.col}>Created</div>
					</div>
					{invites.map((e) => {
						return <Row data={e} key={e._id} />;
					})}
				</div>
			</Card>
		</Modal>
	);
};

export default InviteList;
